import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { STUDY_INSIGHTS_TRANSLATION } from '@/modules/study-insights/constants';

import InfoPanel from '../../../shared/InfoPanel/InfoPanel';
import { StyledInfoPanel } from './LayoutThreeSidePanel.styles';
import { LayoutThreeSidePanelProps } from './LayoutThreeSidePanel.types';
import { PillIds } from '../../../shared/types/PillIds';
import useOrganizationName from '@/modules/my-account/hooks/useOrganizationName';
import { PartnerOrganization } from '@/modules/core/types';
import { formatNumber, numberToPercentage } from '@/modules/study-insights/utils';

export const LayoutThreeSidePanel: FC<LayoutThreeSidePanelProps> = ({
  selectedDateRange,
  selectedSection,
  consentedForRange,
  consentedForRangePercentChange,
  remainingConsentedGoal,
  conversionRateForRange,
  conversionRateForRangePercentChange,
}) => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);
  const organizationName = useOrganizationName();
  const isMemorialHermann =
    organizationName === PartnerOrganization.MEMORIAL_HERMANN ||
    organizationName === PartnerOrganization.HELIX_MEMORIAL_HERMANN;

  return (
    <StyledInfoPanel>
      <InfoPanel
        containerStyles={{ p: '$0' }}
        infoTitle={t('participant_recruitment.section_total', {
          section: t('participant_recruitment.consented.title'),
        }).toLocaleUpperCase()}
        numberText={formatNumber(consentedForRange)}
        previousPeriod={{ percentage: consentedForRangePercentChange, period: selectedDateRange?.selectedDateRange }}
        remaining={remainingConsentedGoal}
      />
      <InfoPanel
        containerStyles={{ p: '$0' }}
        description={
          selectedSection === PillIds.CONSENTED
            ? t('participant_recruitment.consented_description')
            : t(
                `participant_recruitment.${
                  isMemorialHermann ? 'available_for_consent_description' : 'interested_description'
                }`,
              )
        }
        infoTitle={t('participant_recruitment.conversion_rate').toLocaleUpperCase()}
        numberText={numberToPercentage(conversionRateForRange)}
        previousPeriod={{
          percentage: conversionRateForRangePercentChange,
          period: selectedDateRange?.selectedDateRange,
        }}
        // TODO: Hiding goal for now until we have a better understanding of what the goal should be
        conversionRateGoal={0}
      />
    </StyledInfoPanel>
  );
};
